import _ from '../../common/utility';

// Below function to set the flickity carousel for Featured Stories section (.hp_cardlayout)
function featuredCarousel() {
    const featuredElem = $('section.hp_cardlayout div.section-container ul');
    featuredElem.flickity({
        cellAlign: 'left',
		groupCells: true,
		contain: true,
		lazyLoad: true
    });
}
export default _.catch(featuredCarousel);